import { UserCalendrier } from "@/models";
import ProfileService from "@/services/profile.service";
import { Module, VuexModule, Action } from "vuex-class-modules";

/** Actions for the current user's profile settings. */
@Module
export class Profile extends VuexModule {
  /**
   * Updates the current user's calendar preferences.
   * @returns `true` unless the call throws — doesn't check `ProfileService`'s own success/failure result.
   */
  @Action
  async updateParamCalendrier(settings: UserCalendrier): Promise<boolean> {
    try {
      await ProfileService.updateParamCalendrier(settings);
      return true;
    } catch {
      return false;
    }
  }
}
